export enum TermsStatus {
  Draft = 'Draft',
  Published = 'Published',
  Archived = 'Archived'
}

/**
 * One version of the site's policy, exactly as API v2 `/terms` returns it. Audit fields are
 * filled by the server; `publishedAt` / `publishedBy` are omitted until the version is published.
 */
export interface TermsVersion {
  id: string;
  siteId: string;
  versionNumber: number;
  title: string;
  content: string;
  status: TermsStatus;
  createdAt: number;
  createdBy?: string;
  updatedAt?: number;
  updatedBy?: string;
  publishedAt?: number;
  publishedBy?: string;
}

/** The fields create / update send. The server reads only title and content and assigns the rest - status included. */
export interface TermsPayload {
  title: string;
  content: string;
  status?: TermsStatus;
}

/** The approvals panel's list: agents that approved the currently published version, or not yet. */
export enum TermsApprovalStatus {
  Approved = 'Approved',
  Pending = 'Pending'
}

/** Snapshot stored on the agent (`termsVersionApprovalDetailsReference`) of the version it last approved. */
export interface TermsVersionApprovalDetails {
  id: string;
  version: string;
  title: string;
  // Client time of the approval (the app may send it later, when offline).
  approvedAt: number;
  // Server time the approval was received.
  receivedAt: number;
}

export interface PublishedTermsResponse {
  terms: TermsVersion | null;
  approvedCount: number;
  totalCount: number;
}
